import React, { useContext } from "react";
import { TranslatorContext } from "../context/Translator";
import { Row, Col } from "react-bootstrap";
import { ButtonComponent } from "../components/elements";
import PageLayout from "../layouts/PageLayout";
import { useNavigate, useLocation } from "react-router-dom";

export default function NotFoundPage() {
    const { t } = useContext(TranslatorContext);
    const navigate = useNavigate();
    const location = useLocation();

    // Check if this is a permission-based redirect
    const isPermissionDenied = location.state?.permissionDenied;

    const handleGoHome = () => {
        navigate('/');
    };

    return (
            <Row>
                <Col xl={12}>
                    <div>
                        <div className="mc-card-body text-center" style={{ padding: '60px 20px' }}>
                            <div className="error-404">
                                <h1 style={{ 
                                    fontSize: '120px', 
                                    fontWeight: 'bold', 
                                    color: isPermissionDenied ? '#e67e22' : '#e74c3c',
                                    margin: '0',
                                    lineHeight: '1'
                                }}>
                                    {isPermissionDenied ? '403' : '404'}
                                </h1>
                                
                                <div style={{ marginBottom: '30px' }}>
                                    <i className="material-icons" style={{ 
                                        fontSize: '80px', 
                                        color: '#bdc3c7',
                                        display: 'block',
                                        margin: '20px auto'
                                    }}>
                                        {isPermissionDenied ? 'lock' : 'error_outline'}
                                    </i>
                                </div>

                                <h3 style={{ 
                                    color: '#2c3e50', 
                                    marginBottom: '15px',
                                    fontWeight: '600'
                                }}>
                                    {isPermissionDenied 
                                        ? (t('access_denied') || 'Access Denied')
                                        : (t('page_not_found') || 'Page Not Found')
                                    }
                                </h3>
                                
                               

                                <div style={{ 
                                    display: 'flex', 
                                    gap: '15px', 
                                    justifyContent: 'center',
                                    flexWrap: 'wrap'
                                }}>
                                    <ButtonComponent 
                                        className="mc-btn primary"
                                        icon="home"
                                        text={t('go_to_home') || 'Go to Home'}
                                        onClick={handleGoHome}
                                    />
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
    );
}